/**
 *
 * @param newSubDomain
 * @description This function changes the subdomain of the current URL
 * @example
 * changeSubdomain('newsubdomain')
 * @returns
 */

import { MenuDataItem } from '@ant-design/pro-layout'
import { getTokenFromUrl } from '@shared/utils'

export const changeSubdomain = (newSubDomain: string) => {
  const { host, protocol } = window.location
  const domainParts = host.split('.')

  if (domainParts?.length > 1) {
    domainParts.shift()
  }

  const domainAndTld = domainParts.join('.')

  return `${protocol}//${newSubDomain}.${domainAndTld}`
}

export const updateMenuPaths = (
  menuItems?: MenuDataItem[],
  key?: string,
  token = getTokenFromUrl()
): MenuDataItem[] => {
  if (!menuItems || !key) {
    return []
  }

  return menuItems?.map((item) => ({
    ...item,
    // Submenu titles have no path — prefixing an absent one would produce a
    // literal '/apps/<app>/<token>undefined' link.
    path: item?.path ? `/apps/${key}/${token}${item.path}` : undefined,
    children: item.children
      ? updateMenuPaths(item?.children, key, token)
      : undefined
  }))
}
